import theme from '../../theme';
import { styled } from '@mui/material/styles';


export const OlDecimal = styled('ol')(({ theme }) => ({
  fontFamily: '"Open sans", "Noto Sans TC", "sans-serif"',
  fontSize: '1rem',
  fontWeight: 400,
  lineHeight: '1.5',
}))

export const OlCjk = styled('ol')(({ theme }) => ({
  listStyleType: 'cjk-ideographic'
}))

export const OlUpperAlpha = styled('ol')(({ theme }) => ({
  listStyleType: 'upper-alpha'
}))

export const UlCircle = styled('ul')(({ theme }) => ({
  listStyleType: 'circle',
  fontFamily: '"Open sans", "Noto Sans TC", "sans-serif"',
  fontSize: '1rem',
  fontWeight: 400,
  lineHeight: '1.5',
}))

export const LiNormal = styled('li')(({ theme }) => ({
  paddingBottom: '4px'
}))

export const LiBold = styled('li')(({ theme }) => ({
  padding: '4px 0',
  fontWeight: 700,
}))